import { CommonModule } from '@angular/common';
import { ToastModule } from '@shared/components/toast';
// import { SharedComponentModule } from './../shared/shared-component.module';
// import { PhoneNumberModule } from './../shared/phone-number/phone-number.module';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipModule } from '@angular/material/tooltip';
import { MAT_TOOLTIP_OPTIONS } from '@portal/data-access';
import { DatetimeModule, FileSizeModule, SafeSourceHtmlModule } from '../pipes';
import { AddRecipientDialogComponent } from './add-recipient-dialog/add-recipient-dialog.component';
import { ConfirmSubmitBottomSheetComponent } from './confirm-submit-bottom-sheet/confirm-submit-bottom-sheet.component';
import { ConfirmSubmitDialogComponent } from './confirm-submit-dialog/confirm-submit-dialog.component';
import { SigningDeclineModalComponent } from './signing-decline-modal/signing-decline-modal.component';
import { VerifyCodeModalComponent } from './verify-code-modal/verify-code-modal.component';
import { UploadDirective } from '../utils/upload.directive';

@NgModule({
  declarations: [
    SigningDeclineModalComponent,
    VerifyCodeModalComponent,
    ConfirmSubmitDialogComponent,
    ConfirmSubmitBottomSheetComponent,
    AddRecipientDialogComponent,
    UploadDirective,
  ],
  imports: [
    // Pipes
    SafeSourceHtmlModule,
    FileSizeModule,
    DatetimeModule,

    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatProgressBarModule,
    MatMenuModule,
    MatIconModule,
    MatDividerModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatDatepickerModule,
    // NgxMaterialTimepickerModule,
    MatTooltipModule,
    // SharedComponentModule,
    // PhoneNumberModule,
    MatBottomSheetModule,
    MatBadgeModule,
    ToastModule,
  ],
  exports: [
    ConfirmSubmitDialogComponent,
    SigningDeclineModalComponent,
    VerifyCodeModalComponent,
    ConfirmSubmitBottomSheetComponent,
    AddRecipientDialogComponent,
    UploadDirective,
  ],
  providers: [{ provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: MAT_TOOLTIP_OPTIONS }],
})
export class DocumentSigningSharedModule {}
